<template>

  <div class="workshops-bespoke">

    <nav-1></nav-1>

    <hero :image="hero"></hero>

    <!-- <div class="hero-wrapper">
      <div class="hero">
        <div class="background" :style="{'backgroundImage':'url(' + hero + ')'}"></div>
        <div class="text">

        </div>
      </div>
    </div> -->

    <div class="content-text">
      <h1>Private & Corporate Workshops</h1>
      <h4 class="size__content__default pos__content__center">
        A Learn with Hato workshop is a great way to celebrate an event or bring colleagues together. We have hosted zine-making, typeface design, terrarium-building and other creative workshops in the past. With an in-house team of design & printing experts and a network of creative collaborators, our curated experiences are tailored to your specific requirements – in&#8209;house or offsite, analog or digital, party or masterclass. Take a look at these sample bespoke&nbsp;workshops:
      </h4>
    </div>




    <div class="products-wrapper">
      <h2>Sample Bespoke Workshops</h2>
      <div class="products size__content__wide pos__content__center">
        <div class="product" v-for="(p, index) in products">
          <h2 class="--flash" v-html="p.title"></h2>
          <p>{{p.text}}</p>
          <ul>
            <li v-for="k in p.key">{{k}}</li>
          </ul>
          <div class="action">
            <a href="mailto:bespoke@hatopress.net">Enquire</a>
          </div>
        </div>
      </div>

      <div class="action">
        <h3>Not what you’re looking for? Let us customise your next event with a bespoke workshop.</h3>
        <a href="mailto:bespoke@hatopress.net?subject=Bespoke Workshops">bespoke@hatopress.net</a>
        <a href="tel:+44-207-729-5585">+44 (0)207 729 5585</a>
      </div>

        <!-- <p class="size__content__narrow pos__content__center">All materials are provided unless specified. Workshops can be held onsite at our studio in Hoxton, London or at your location (subject to availability). Complimentary dood and drinks are included but&nbsp;optional.</p> -->
    </div>




    <div class="quotes size__content__wide pos__content__center">
      <div class="quote">
        <h3>“Our creative team loved the chance to roll up our sleeves and learn risoprinting from one of the finest studios in London. The session was well run. Hats off to Hato.”</h3>
        <p>Shirley, Senior Copywriter, Virgin Media</p>
      </div>
      <div class="quote">
        <h3>“The two colour workshop was perfect for our group to experiment and get creative. We learnt loads and would recommend to anyone!”</h3>
        <p>Emma, Graphic Designer, Boden</p>
      </div>
      <div class="quote">
        <h3>“We have a great Riso printing session at Hato, really learnt a lot and was great fun. Was a great way to work on something different whilst enjoying a beer ;-).”</h3>
        <p>Alex Prior, Head of Graphic Design at The Hoxton</p>
      </div>
      <div class="quote">
        <!-- <h3>“The Hato Christmas Card workshop was the perfect activity for the team to get out the office and learn and do something new together. Most had very little knowledge of Riso before hand and so was a lot of fun making a mess together, experimenting with ideas and picking your colours! The instructors were amazing, offering motivation and tips throughout. We came away with a new appreciation for the risograph print process, along with some fantastic printed cards (some showing more creative skill than others!).”</h3> -->
        <h3>“The Hato Christmas Card workshop was the perfect activity for the team to get out the office and learn and do something new together. The instructors were amazing, offering motivation and tips throughout. We came away with a new appreciation for the risograph print process, along with some fantastic printed cards (some showing more creative skill than others!).”</h3>
        <p>Helen Scibilia, Project Manager, YCN</p>
      </div>
      <!-- <div class="quote">
        <h3>“Our creative team loved the chance to roll up our sleeves and learn risoprinting from one of the finest studios in London. The session was well run. Hats off to Hato.”</h3>
        <p>Shirley, Senior Copywriter, Virgin Media.</p>
      </div> -->
    </div>




    <!-- <div class="content-text">
      <img class="size__content__narrow" src="../assets/clients/corporate-logo-blocks.png" alt="">
    </div> -->
    <div class="content-logos">
      <img class="size__content__narrow" src="../assets/clients/corporate-logo-blocks.png" alt="">
    </div>
    <!-- <div class="content-text">
      <p>&nbsp;</p>
    </div> -->
    <!-- <div class="action-wrapper">
      <div class="action">
        <h3>Let us plan your next event,<br>book a bespoke session with us.</h3>
        <a href="#">learn@hatopress.net</a>
        <a href="#">+44 (0)207 729 5585</a>
      </div>
    </div> -->

  </div>

</template>

<script>

import Nav1 from '@/components/Nav1'
import Flickity from '@/components/Flickity'
import Hero from '@/components/Hero'
import Newsletter from '@/components/Newsletter'

export default {
  ready: function () {
    let self = this
    window.addEventListener('resize', self.handleResize)
  },
  beforeDestroy: function () {
    let self = this
    window.addEventListener('resize', self.handleResize)
  },
  components: {
    Nav1,
    Flickity,
    Hero,
    Newsletter
  },
  data () {
    return {
      hero: require('../assets/workshops/hatopress-whitechapel-closeup.jpg'),
      products: [
        {
          title: 'Make a zine',
          text: 'Flex your creative muscles and learn how to build and print your own zine.',
          key: [
            'Learn about riso printing and basic bookbinding skills',
            'Leave with a set number of prints and a zine containing prints from other participants',
            'Design a cover with participants from your group',
            'Complimentary food and drinks are included but optional'
          ]
        },
        {
          title: 'Riso party',
          text: 'We’ll begin with an introduction and a test exercise on riso-printing. Then it’s your turn to experiment and artwork using a range of materials.',
          key: [
            'Learn about riso printing and see the live printing action',
            'Choose to print your designs as A3/A4 prints or on a set of postcards, cards, wrapping paper',
            'Complimentary food and drinks are included but optional'
          ]
        },
        {
          title: 'Hato Experience Day',
          text: 'Explore the thriving community around our studio and create a riso-print as a token from your day out.',
          key: [
            'We’ll meet at our studio then it’s off to getting your artisanal caffeine fix from one of our local coffee shops',
            'Explore Columbia Road Flower Market, only a stone\'s throw away from Hato Press',
            'Take your botanical purchases from the market or use our materials to create your own rubbings ',
            'Learn about pattern-making and risograph printing',
            'Transform your artwork into a riso-print and take home 10 copies',
            'Complimentary food and drinks are included but optional'
          ]
        }
        // {
        //   title: 'Build a glass&nbsp;garden',
        //   text: 'The workshop starts with a brief history on terrarium-making, then it is time to get your hands dirty and build your own.',
        //   key: [
        //     'Take home your own miniature bottled garden',
        //     'All terrarium contents, jar and tools are included',
        //     'Work with various Fittonia, Ivy and an arrangement of pebbles and moss',
        //     'Choose from 2 sizes of terrarium jars',
        //     'Complimentary food and drinks are included but optional'
        //   ]
        // }
        // ,
        // {
        //   title: 'Custom Events',
        //   text: 'Do whatever you want!',
        //   key: [
        //     'Take home your own miniature bottled garden',
        //     'All terrarium contents, jar and tools are included',
        //     'Work with various Fittonia, Ivy and an arrangement of pebbles and moss',
        //     'Choose from 2 sizes of terrarium jars',
        //     'Complimentary food and drinks are included but optional'
        //   ]
        // }
      ],
      carousel: [
        {
          text: 'Bao',
          image: 'https://scontent-lhr3-1.cdninstagram.com/t51.2885-15/e35/17438461_174435699740537_1721658144775471104_n.jpg'
        }
      ],
      flickityOptions: {
        // contain: true,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true,
        autoPlay: 3000
      }
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
  margin-top: 0;
  /*text-align: center;*/
}
img {

}
.content-text {
  background: #fdda58;
  background: #fff;
  margin: auto;
  padding: 1rem 1rem 1rem;
  margin: 0 auto;
  text-align: left;
  /*max-width: 1000px;*/
}

.content-text h4 {
  margin-bottom: 1rem;
}

.content-logos {
  margin: 4rem auto 6rem;
}

.action-wrapper {
  /*background: #f0f0f0;*/
  padding: 1rem 0;
}

.action {
  padding: 2rem 0;
  margin: 0 auto;
  max-width: 600px;
  text-align: center;
}
.action a {
  display: inline-block;
  margin: 1rem .5rem;
  padding: .5em 1em;
  border-radius: 5px;
  /*border: 1px solid #000;*/
  background: hsl(158, 81%, 57%)
}
.action a:hover {
  background: hsl(158, 81%, 77%);
}


.products-wrapper {
  background: #eee;
  background: hsl(158, 81%, 77%);
  padding: 2rem 0 3rem;
  margin: 1rem 0 2rem;
}
.products-wrapper h2 {
  margin-bottom: 2rem;
  text-align: center;
}
.products {
  /*filter: url('#goo');*/
  display: flex;
  /*max-width: 1000px;*/
  margin: 0 auto 2rem;
  justify-content: center;
  /*flex-wrap: wrap;*/
}
.product {
  /*width: 50%;*/
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 1;
  background: white;
  width: 400px;
  padding: 2rem 2rem 2rem;
  margin: .5rem;
  display: flex;
  flex-direction: column;
  /*border-radius: 100px;*/
}
/*.product:nth-child(1) {
  background: pink;
  transform: translate3d(30px,0,0);
}
.product:nth-child(2) {
  background: blue;
  transform: translate3d(0,0,0);
}*/
.product h2 {
  /*font-size: 2rem;*/
  text-align: center;
  line-height: 1.2;
  margin: 1rem 0 2rem;
  font-weight: 400;
  /*width: 5rem;
  height: 5rem;
  border-radius: 50%;*/
  /*background: hsl(360, 100%, 75%);*/
  /*text-shadow: 0px 0px 30px hsl(158, 81%, 57%);*/
  /*color: black;*/
}
.product p {
  margin-bottom: 1em;
}
.product ul {
  padding-left: 1rem;
}
.product ul, .product li {
  list-style: disc;
}
.product .action {
  padding: 1.5rem .5rem.5rem;
  margin: auto 0 0;
}
.product .action a {
  margin: 0;
}

.products-wrapper > .action a {
  background: hsl(0,0%,95%)
}
.products-wrapper > .action a:hover {
  background: hsl(0,0%,100%)
}


.flash {
   animation-name: flash;
    animation-duration: 1s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-play-state: running;
}


@keyframes flash {
    0% {color: red;}
    20% {color: yellow;}
    40% {color: green;}
    60% {color: blue;}
    80% {color: pink;}
    100% {color: red;}
}


/*.hero-wrapper {
  width: 100%;
  margin: auto;
}
.hero {
  position: relative;
  margin: 0 0;
  height: 0;
  max-width: 100%;
  padding-bottom: 50%;
  overflow: hidden;
  background: #fdda58;
  display: flex;
  text-align: center;
  justify-content: center;
  align-content: center;
}
.hero .background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
  filter: saturate(1);
}
.hero .text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  z-index: 99;
}
.hero h1 {
  font-size: 3.5rem;
  font-weight: 700;
  color: white;
  text-transform: uppercase;

}*/





.quotes {
  /*max-width: 1000px;*/
  padding: 0rem 0 0rem;
  /*margin: auto;*/
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  /*flex-direction: column;*/
}
.quote {
  /*max-width: 600px;*/
  width: 49%;
  padding: 2rem 2rem 1rem;
  margin: 1rem 0;
  border-radius: 5px;
  background: hsl(186, 81%, 57%);
}
.quote:nth-child(2n) {
  background:
  /*align-self: flex-end;*/
}



.layout-b {
  /*background: rgb(55,234,168);*/
  max-width: 100%;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 1024px) {
  .products {
    padding-left: .5rem;
    padding-right: .5rem;
  }
  .product {
    padding: 1rem 1rem 1rem;
    margin: .25rem;
  }
  .quotes {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .content-logos {
    margin-top: 1rem;
    margin-bottom: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
@media screen and (max-width: 768px) {
    .products {
      flex-direction: column;
      margin-bottom: 1rem;
    }
    .product {
      width: 100%;
      margin-left: auto;
      margin-right: auto;
    }
    .product .action {
      margin-left: auto;
      margin-right: auto;
    }
    .products-wrapper {
      margin-bottom: 1rem;
      padding-top: 1rem;
      padding-bottom: 1rem;
    }
    .products-wrapper > .action {
      margin-top: 1rem;
      margin-bottom: 1rem;
      padding-left: 1rem;
      padding-right: 1rem;
      padding-top: 1rem;
      padding-bottom: 1rem;
    }
}
@media screen and (max-width: 640px) {
  .quotes {
    flex-direction: column;
  }
  .quote {
    width: 100%;
    margin-top: 0;
    margin-bottom: 1rem;
  }
  .action a {
    margin: .5em 1em;
  }
}
</style>



// WEBPACK FOOTER //
// WorkshopsBespoke.vue?71ad144b